import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/Common.module.css';
import Button from '../../Styles/Button.module.css';
import { Link } from "react-router-dom";
import { IoArrowForwardCircleOutline } from "react-icons/io5";

const PostLandingPage= ()=>{
    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };
    return(
        <div className={Style.businessPage}>
           <section className={Style.clear + " "+Style.breadcrumb}>
                <Container>
                <Row>
                    <Col>
                        <ul>
                            <li><Link to="/">Home </Link></li>
                            <li><Link to='/community'>Community</Link></li>
                            <li>Posts</li>
                        </ul>
                    </Col>
                </Row>
                </Container>
            </section>
            <div className={Style.pageTitle + ' ' + Style.marginUp90}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Style.sectionTitle}>
                                <h2>Posts</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className={Style.twoColSpace}>
                        <Col md={6}>
                            <div className={Style.communityContainer}>
                                <figure>
                                    <img src={require('../../../assest/images/community-img02.png')} />
                                </figure>
                                <div className={Style.communitelement}>
                                    <img src={require('../../../assest/images/business-listinr-icon01.png')} />
                                    <h3><Link to='/view-posts-listing' >VIEW POSTS</Link></h3>
                                    <p>View Announcements, Updates & News Posted By Mayo Alumni Community</p>
                                    <Link to='/view-posts-listing' className={Button.goGreenBtn + ' ' + Style.communityLink}><IoArrowForwardCircleOutline /></Link>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className={Style.communityContainer}>
                                <figure>
                                    <img src={require('../../../assest/images/business-directory-img02.png')} />
                                </figure>
                                <div className={Style.communitelement}>
                                    <img src={require('../../../assest/images/business-listinr-icon02.png')} />
                                    <h3><Link to='/post-create'>SUBMIT POST</Link></h3>
                                    <p>Submit Announcements, Updates & News To Mayo Alumni Community</p>
                                    <Link to='/post-create' className={Button.goGreenBtn + ' ' + Style.communityLink}><IoArrowForwardCircleOutline /></Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default PostLandingPage;